import styled from 'styled-components'

import { SecondaryButton } from '@ui/elements/Button'

export const UploadButtonStyled = styled(SecondaryButton)``
